import { CardColorStrategy } from '@atlassian/jira-software-board-settings-rapidboard-config-common/src/common/types/card-colors.tsx';

export const shouldShowSkeleton = (cardColorStrategy: CardColorStrategy | null) =>
	!!cardColorStrategy && cardColorStrategy !== CardColorStrategy.none;
